import { formatDate } from './dates.js';
// Formats a known amount in a known ISO currency, always with the explicit
// code in front ("CAD $56.44", "USD $3.10", "EUR €12.00") so a bare "$" never
// leaves the reader guessing which dollar. Returns null when either the amount
// or the currency is missing: callers show "unavailable", never a default.
export function money(amount, currency) {
  if (amount === null || amount === undefined || amount === '' || !Number.isFinite(Number(amount))) return null;
  if (typeof currency !== 'string' || !/^[A-Z]{3}$/i.test(currency)) return null;
  const code = currency.toUpperCase();
  let body;
  try {
    body = new Intl.NumberFormat(undefined, { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' }).format(Number(amount));
  } catch {
    body = Number(amount).toFixed(2);
  }
  // Some locales already prefix the code or a qualified symbol (US$, CA$);
  // strip that so the output is one explicit code plus a plain symbol amount.
  body = body.replace(/^[A-Z]{2,3}\s?\$?/, (m) => (m.endsWith('$') ? '$' : '')).trim();
  return `${code} ${body}`;
}

// price_sources entries may be plain strings or {source, currency, as_of}.
// One readable string each: "TCGplayer (USD, 2026-09-12)".
export function formatPriceSource(item) {
  if (item === null || item === undefined) return '';
  if (typeof item === 'string') return item;
  if (typeof item !== 'object') return String(item);
  const name = item.source || item.name || item.provider || '';
  const bits = [];
  if (item.currency) bits.push(String(item.currency).toUpperCase());
  if (item.as_of) { const f = formatDate(item.as_of); if (f) bits.push(f); }
  return bits.length ? `${name || 'price'} (${bits.join(', ')})` : (name || '');
}

export function formatPriceSources(list) {
  if (!Array.isArray(list)) return '';
  return [...new Set(list.map(formatPriceSource).filter(Boolean))].join(' · ');
}
